module.exports = __webpack_public_path__ + "static/antd-table-pagination-a17a627fbf5481b510f3457b915d345b.png";